import React from 'react';
import { Box, Typography } from '@mui/material';

// Helper: map Square fulfillment states to our custom status
export const mapSquareStatusToCustomStatus = (fulfillments, fallbackStatus) => {
  if (!fulfillments || fulfillments.length === 0) return fallbackStatus;
  const fulfillment = fulfillments[0];
  const squareState = fulfillment?.state;
  switch (squareState) {
    case 'PROPOSED':
      return 'new';
    case 'RESERVED':
      return 'inprogress';
    case 'PREPARED':
      return 'ready_to_pickup';
    case 'COMPLETED':
      return 'delivered';
    case 'CANCELED':
      return 'cancelled';
    case 'FAILED':
      return 'inprogress';
    default:
      return fallbackStatus;
  }
};

export const getOrderStatus = (order) => {
  if (!order) return null;
  const {
    deliveryOption,
    order_delivery_status,
    fulfillments = [],
    order_status,
  } = order;
  if (deliveryOption === 'delivery' && order_delivery_status)
    return order_delivery_status;
  if (fulfillments && fulfillments.length > 0)
    return mapSquareStatusToCustomStatus(fulfillments, order_status);
  return order_status;
};

export const getStatusDisplay = (status) => {
  switch (status) {
    case 'cancelled':
      return 'Cancelled';
    case 'delivered':
      return 'Delivered';
    case 'pending':
      return 'Pending';
    case 'confirmed':
      return 'Confirmed';
    case 'inprogress':
      return 'In Progress';
    case 'new':
      return 'Order Placed';
    case 'ready_to_pickup':
      return 'Ready to Pickup';
    case 'scheduled':
      return 'Scheduled';
    case 'created':
      return 'Created';
    case 'assigned':
      return 'Assigned to Driver';
    case 'batched':
      return 'Batched for Delivery';
    case 'awaiting_pickup':
      return 'Awaiting Pickup';
    case 'pickedup':
      return 'Picked Up';
    case 'arrived_at_destination':
      return 'Arrived at Destination';
    default:
      return status;
  }
};

export const getStatusStyles = (status) => {
  switch (status) {
    case 'cancelled':
      return { bgColor: '#FFEAEA', textColor: '#FF3B30', dotColor: '#FF3B30' };
    case 'delivered':
      return { bgColor: '#E6F7EE', textColor: '#34C759', dotColor: '#34C759' };
    case 'inprogress':
    case 'new':
    case 'created':
    case 'confirmed':
    case 'ready_to_pickup':
    case 'scheduled':
    case 'assigned':
    case 'batched':
    case 'awaiting_pickup':
    case 'pickedup':
    case 'arrived_at_destination':
      return { bgColor: '#EAF3FF', textColor: '#007AFF', dotColor: '#007AFF' };
    default:
      return { bgColor: '#F3F6F9', textColor: '#404040', dotColor: '#404040' };
  }
};

const OrderStatusBadge = ({ order, mappedStatus }) => {
  const status = mappedStatus || getOrderStatus(order) || 'unknown';
  const styles = getStatusStyles(status);
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '4px 12px',
        gap: '8px',
        borderRadius: '40px',
        fontSize: '14px',
        fontWeight: 400,
        bgcolor: styles.bgColor,
        color: styles.textColor,
        boxShadow: 'none',
      }}
    >
      <Box
        sx={{
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          bgcolor: styles.dotColor,
          fontFamily: 'Jost, sans-serif',
        }}
      />
      <Typography sx={{ fontSize: '14px' }}>
        {getStatusDisplay(status)}
      </Typography>
    </Box>
  );
};

export default OrderStatusBadge;
